import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
var AddresolutionComponent = /** @class */ (function () {
    function AddresolutionComponent(fb, transMngSer, tostr, dialogRef, formdata) {
        this.fb = fb;
        this.transMngSer = transMngSer;
        this.tostr = tostr;
        this.dialogRef = dialogRef;
        this.formdata = formdata;
        this.siteName = [];
        this.action = "add";
        this.loginUserData = JSON.parse(localStorage.getItem("userData"));
        this.selectedMaintainance = [];
    }
    AddresolutionComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.formGroup = this.fb.group({
                            sitename: new FormControl(null, [Validators.required]),
                            transformerid: new FormControl(''),
                            maintainance: new FormControl(null, [Validators.required]),
                            date: new FormControl(null, [Validators.required]),
                            resolutionmethod: new FormControl(null, [Validators.required]),
                            engineername: new FormControl(null, [Validators.required]),
                            partreplaced: new FormControl(null, [Validators.required]),
                            rootcause: new FormControl(null, [Validators.required]),
                            transformerstatus: new FormControl(null, [Validators.required]),
                            notes: new FormControl(null),
                        });
                        _a = this;
                        return [4 /*yield*/, this.getDdlData()];
                    case 1:
                        _a.siteName = _b.sent();
                        this.sitemanagers = this.siteName.map(function (site) { return site.sitemanager; });
                        if (typeof this.formdata == 'object' && !Array.isArray(this.formdata)) {
                            console.log("form data", this.formdata);
                            this.action = "edit";
                            this.patchFormData(this.formdata);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AddresolutionComponent.prototype.getTransformerID = function (sitename) {
        this.selectedSite = sitename.serialnumber;
        this.formGroup.controls['transformerid'].setValue(sitename.serialnumber);
        this.getData();
    };
    AddresolutionComponent.prototype.getDdlData = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.transMngSer.getTransformerData(JSON.parse(localStorage.getItem('userData')).roleid, JSON.parse(localStorage.getItem('userData')).userid, 'x``z').toPromise().then(function (response) {
                if (response.data.length > 0) {
                    resolve(response.data);
                }
                resolve([]);
            });
        });
    };
    AddresolutionComponent.prototype.getData = function () {
        var _this = this;
        this.transMngSer.getMaintenancePlanningData({ "userid": this.loginUserData.userid, "transformerid": this.selectedSite }).toPromise().then(function (response) {
            if (response.code == 1) {
                console.log("data", response.data);
                _this.selectedMaintainance = response.data;
            }
        });
    };
    AddresolutionComponent.prototype.submit = function (formdata) {
        var _this = this;
        var maintenanceData = formdata.value;
        maintenanceData.login_user_id = this.loginUserData.userid;
        var msg = "Plan Created";
        if (this.action == "edit") {
            maintenanceData.id = this.formdata['id'];
            msg = "Plan Updated";
        }
        var resolutionData = formdata.value;
        var matchingObject = this.selectedMaintainance.find(function (item) { return item.selectedOptions == resolutionData.maintainance; });
        var id = matchingObject ? matchingObject.id : null;
        resolutionData.maintainancePlanningID = id;
        resolutionData.loginuserid = this.loginUserData.userid;
        this.transMngSer.addResolution(resolutionData).toPromise().then(function (response) {
            if (response.code == 1) {
                _this.tostr.success("created");
                _this.dialogRef.close();
            }
        });
        console.log(resolutionData);
    };
    AddresolutionComponent.prototype.patchFormData = function (valuesObject) {
        var _this = this;
        this.selectedMaintainance = [{ "selectedOptions": valuesObject.maintainance }];
        this.formGroup.patchValue({
            sitename: valuesObject.sitename,
            transformerid: valuesObject.transformerid,
            maintainance: valuesObject.maintainance,
            date: new Date(valuesObject.currentdatetime),
            resolutionmethod: valuesObject.resolutionmethod,
            engineername: valuesObject.engineername,
            partreplaced: valuesObject.partreplaced,
            rootcause: valuesObject.rootcause,
            transformerstatus: valuesObject.transformerstatus,
            notes: valuesObject.comments,
        });
        Object.keys(this.formGroup.controls).forEach(function (field) {
            var control = _this.formGroup.get(field);
            if (control) {
                control.disable();
            }
        });
    };
    AddresolutionComponent.prototype.editData = function () {
        var _this = this;
        Object.keys(this.formGroup.controls).forEach(function (field) {
            var control = _this.formGroup.get(field);
            if (control) {
                control.enable();
            }
        });
    };
    return AddresolutionComponent;
}());
export { AddresolutionComponent };
